module.exports = {
    capitalize:                 require('./src/capitalize'),
    getQueryByParamName:        require('./src/getQueryParamByName'),
    windowlessrouter:           require('./src/windowlessrouter'),
    roundByLargestRemainder:    require('./src/roundByLargestRemainder'),
    urlencode:                  require('./src/urlencode'),
    ie9ajaxshim:                require('./src/ie9ajaxshim'),
    jqueryKnob:                 require('./src/jqueryKnob'),
    storageUtil:                require('./src/storage')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-util/index.js
// module id = 57
// module chunks = 0